import { useState, useEffect } from 'react'

export const usePageSpeed = () => {
  const [isPageSpeedDetected, setIsPageSpeedDetected] = useState(false)
  const [isClient, setIsClient] = useState(false)

  const detectPageSpeed = () => {
    if (typeof window === 'undefined' || !window.navigator) {
      return false
    }

    const ua = window.navigator.userAgent

    // Regex checks no user-agent (não depende de versão exata do Chrome)
    const uaMatch = /Chrome-Lighthouse|Speed Insights|PSTS\/\d|moto g power/i.test(ua)

    // Flag injetada pelo Lighthouse quando roda via Node
    const lighthouseFlag = !!(window as any).__lighthouseNodeExecutionContext

    // Detecção de browser headless
    const isWebdriver = navigator.webdriver === true
    const noPlugins = navigator.plugins.length === 0

    // Headless browsers não possuem media stack completo
    const video = document.createElement('video')
    const noVideoCodec = !video.canPlayType('video/webm; codecs="vp9"')

    // noPlugins + noVideoCodec combinados com AND para evitar falso-positivos
    return uaMatch || lighthouseFlag || isWebdriver || (noPlugins && noVideoCodec)
  }

  useEffect(() => {
    setIsClient(true)
    setIsPageSpeedDetected(detectPageSpeed())
  }, [])

  return {
    isPageSpeed: isPageSpeedDetected,
    isClient,
    shouldRenderContent: isClient && !isPageSpeedDetected
  }
}